import promotionTypes from 'src/js/modules/paywall/constants/promotion-types';
import isDifmOfferBannerVisible from 'src/js/modules/paywall/helpers/is-difm-offer-banner-visible';
import isLimitedOfferAvailable from './is-limited-offer-available';

const getActivePromotions = ({
  premiumFeature,
  isNnDifmPromoFeatureFlagEnabled,
  isFreeTrialUpsellFeatureFlagEnabled,
  isFreeTrialAvailable,
}) => {
  if (!isNnDifmPromoFeatureFlagEnabled && !isFreeTrialUpsellFeatureFlagEnabled) {
    return [promotionTypes.NOT_SET];
  }

  const activePromotions = [];

  if (isFreeTrialAvailable) {
    activePromotions.push(promotionTypes.FREE_TRIAL);
  }

  const isLimitedOffer = isNnDifmPromoFeatureFlagEnabled && isLimitedOfferAvailable();
  const isVisibleDifmBanner = isLimitedOffer && isDifmOfferBannerVisible(premiumFeature);

  if (isVisibleDifmBanner) {
    activePromotions.push(promotionTypes.DIFM_BANNER);
  }

  if (isLimitedOffer) {
    activePromotions.push(promotionTypes.DIFM_BADGE);
  }

  if (activePromotions.length === 0) {
    activePromotions.push(promotionTypes.NOT_SET);
  }

  return activePromotions;
};

export default getActivePromotions;
